export default [
  {
    path: "/fatura-takip",
    name: "fatura_takip",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "fatura_takip.Baslik",
      yetki: { k: [1320102] },
    },
  },
]
